<template>
<w-settings-content-template>
  <el-tabs slot="content" class="content-tap" type="card" v-model="activeTab">
    <el-tab-pane label="개별 등록" name="WProcessIndividualRegistView" class="h100 w100">
      <w-process-individual-regist-view/>
    </el-tab-pane>
    <el-tab-pane label="일괄 등록" name="WProcessBatchRegistView" class="h100 w100">
      <w-process-batch-regist-view :activeTab="activeTab" />
    </el-tab-pane>
    <el-tab-pane label="템플릿 설정" name="WProcessTemplateSettingView" class="h100 w100">
      <w-process-template-setting-view :activeTab="activeTab" />
    </el-tab-pane>
  </el-tabs>
</w-settings-content-template>
</template>

<script>
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import WProcessIndividualRegistView from './ProcessIndividualRegistView';
import WProcessBatchRegistView from './ProcessBatchRegistView';
import WProcessTemplateSettingView from './ProcessTemplateSettingView';

export default {
  name: 'MajorProcessRegistView',
  components: {
    WSettingsContentTemplate,
    WProcessIndividualRegistView,
    WProcessBatchRegistView,
    WProcessTemplateSettingView,
  },
  data() {
    return {
      activeTab: 'WProcessIndividualRegistView',
    };
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/server/ProcessSettings/MajorProcessRegistView/index.vue